import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MingaIdentityComponent } from './MingaIdentity.component';

@NgModule({
  imports: [CommonModule],
  declarations: [MingaIdentityComponent],
  exports: [MingaIdentityComponent],
})
export class MingaIdentityModule {}
